export const LESSON = '/lesson/' as const
export const LESSON_ALL = `${LESSON}all` as const
export const LESSON_SORTING = `${LESSON}sorting` as const
export const LESSON_HOMEWORK_UPLOAD = `${LESSON}homework` as const
export const LESSON_ASSESSMENT = `${LESSON}assessment/` as const
export const LESSON_DISTANCE_LEARNING = `${LESSON}distance-learning/` as const
export const LESSON_DISTANCE_LEARNING_ALL = `${LESSON_DISTANCE_LEARNING}all` as const
export const LESSON_ASSESSMENT_ALL = `${LESSON_ASSESSMENT}all` as const
export const LESSON_DOWNLOAD_FILES = `${LESSON}zip` as const

export const LESSON_ATTENDANCE = '/attendance/all/v2'
export const LESSON_ATTENDANCE_GROUP = '/attendance/all/group/v2'
